import React from "react";
import { Form, FormGroup, FormLabel, Row, Col } from "react-bootstrap";
import SubmitControl from "../../../core/SubmitControl";
import { labels } from "../../../../localization/labels";
import { messages } from "../../../../localization/messages";

const BasicRegistration = props => (
  <div>
    <FormGroup
      controlId="username"
      as={Row}
      className="form-group required"
      hidden={!props.enablement.username}
    >
      <FormLabel column sm="4" className="control-label">
        {labels.username}
      </FormLabel>
      <Col sm="8">
        <SubmitControl
          autoFocus
          required
          placeholder={labels.usernamePlaceholder}
          type="text"
          value={props.username}
          onChange={props.onChange}
          valid={props.validation.username}
        />
        <Form.Control.Feedback type="invalid">
          {messages.username_taken}
        </Form.Control.Feedback>
      </Col>
    </FormGroup>
    <FormGroup
      controlId="password"
      as={Row}
      className="form-group required"
      hidden={!props.enablement.password}
    >
      <FormLabel column sm="4" className="control-label">
        {labels.password}
      </FormLabel>
      <Col sm="8">
        <SubmitControl
          required
          placeholder={labels.passwordPlaceholder}
          type="password"
          value={props.password}
          onChange={props.onChange}
          valid={props.validation.password.valid}
        />
      </Col>
    </FormGroup>
    <FormGroup
      controlId="passwordConfirm"
      as={Row}
      className="form-group required"
      hidden={!props.enablement.passwordConfirm}
    >
      <FormLabel column sm="4" className="control-label">
        {labels.confirmPassword}
      </FormLabel>
      <Col sm="8">
        <SubmitControl
          required
          placeholder={labels.passwordPlaceholder}
          type="password"
          value={props.passwordConfirm}
          onChange={props.onChange}
          valid={props.validation.password.valid}
        />
        <Form.Control.Feedback type="invalid">
          {props.validation.password.messages}
        </Form.Control.Feedback>
      </Col>
    </FormGroup>
  </div>
);

export default BasicRegistration;
